module.exports = __webpack_public_path__ + "img/ld_1920.68a6f756.png";